<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :label-width="'80px'" :get-action="queryApi"
      :serial="serial" :selection="selection" :row-style="rowStyleFun" @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu" :before-reset-search="beforeResetSearch">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('rateCalculator.table.CustomerName')" prop="customName">
            <BjInput v-model="queryParams.customName" :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('rateCalculator.table.CustomerName')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.createTimeText')">
            <BjDateRangePicker v-model="dataTime" :placeholder="$t('table.createTimeText')" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsBrand.page.Status')" prop="status">
            <BjSelectLov v-model="queryParams.status" :option-list="STATUS_RATE_CALCULATOR" :placeholder="$t('goodsBrand.page.Status')" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" class="main-btn" @click="add">{{ $t('InternalRefundOrderDetailsOnly.Upload')}}</el-button>
          <el-button type="primary" @click="showRuleDialog">{{ $t('InternalRefundOrderDetailsOnly.LogisticsRules')}}</el-button>
          <el-button type="primary" @click="bulkCancel">{{ $t('bulkDelCancelText')}}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center"
            class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'isCompleted'">
                <el-tag v-if="scope.row.isCancel==1">{{ $t('canceledText') }}</el-tag>
                <el-tag v-else>{{ $t(CSG_rateCalculato_STATUS_ADMIN.bjGet(scope.row[col.prop])) }}</el-tag>
              </template>
              <template v-else-if="col.prop === 'profitMargin'">{{ isNaN(scope.row[col.prop]) ? scope.row[col.prop] :
                scope.row[col.prop] *100/100 + '%' }}</template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'"
            align="center">
            <template slot-scope="scope">
              <el-button type="text" class="edit-btn" @click="addType(scope.row)">{{ $t('viewText') }}</el-button>
              <el-dropdown v-hasDropdownChildren @command="command($event, scope.row)">
                <span class="el-dropdown-link">{{ $t('AccountManagement.common.operate') }}<i
                    class="el-icon-arrow-down el-icon--right" /></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="editText"> {{ $t('editText') }} </el-dropdown-item>
                  <el-dropdown-item command="downloadText"> {{ $t('downloadText') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <DataForm ref="DataForm" @reFresh="reFresh"></DataForm>
    <el-dialog :title="`${$t('editText')}`" :visible.sync="dialogFormVisible" width="400px">
      <el-form ref="form" :model="form">
        <el-form-item prop="profitMargin" :label="$t('rateCalculator.table.profitmargin') + ':'" :rules="[
          { required: true, message: $t('rateCalculator.table.pleaseNumber'), trigger: 'blur' }
        ]">
          <BjInputMoney v-model="form.profitMargin" :max="90" :min="0" :placeholder="$t('inputText')" clearable />
          <!-- <BjInputMoney v-model="form.profitMargin" style="width: 300px;" /> -->
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="saveAmount">{{ $t('okText') }}</el-button>
      </div>
    </el-dialog>
    <!--  路由规则弹窗  -->
    <el-dialog :title="`${$t('InternalRefundOrderDetailsOnly.LogisticsRules')}`" :visible.sync="rulesDialogVisible" width="65%">
      <RulesContent></RulesContent>
    </el-dialog>
  </div>
</template>

<script>
import pageMiXin from '@/utils/page-mixin.js';
import { afterApi,thirdApi } from '@/api';
import { CSG_rateCalculato_STATUS_ADMIN,STATUS_RATE_CALCULATOR } from '@/utils/constants';
import { STATUS_ENABLED_NUM } from '@/utils/constants';
import DataForm from "./copponents/DataForm.vue"
import { downloadBlob } from '@/utils/index';
import RulesContent from "./copponents/rulesContent";
export default {
  name: 'BusinessrateCalculator',
  mixins: [pageMiXin],
  components: { DataForm, RulesContent },
  data() {
    return {
      queryApi: afterApi.detailsCustomerList,
      // queryApi: afterApi.detailsLists,
      CSG_rateCalculato_STATUS_ADMIN,
      STATUS_RATE_CALCULATOR,
      form: { profitMargin: null, id: null },
      forms: {
        profitMargin: null,
        orderNumber: null,
        deliveryAddress: null,
        skus: null,
        volume: null,
        customerPrice: null,
        fromAddress: {},
        toAddresses: [],
        itemGroups: []
      },
      fromAddress: {},
      logistics: [],
      // 查询参数
      queryParams: {
        customName: null,
        startDate: null,
        endDate: null
      },
      dataTime: [],
      rules: {
        cusId: [{ required: true, message: this.$t('inputText'), trigger: 'change' }],
        orderDetails: [{ required: true, message: this.$t('inputText'), trigger: 'change' }],
        totalPalletQty: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        standardPallet: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        chepPallet: [{ required: true, message: this.$t('inpu tText'), trigger: 'blur' }],
        loscomPallet: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        csgPallet: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        shripWrapQty: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        liftOnQty: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        strapWrapQty: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      },
      labelList: [
        // { label: this.$t('rateCalculator.table.PrimaryKeyID'), prop: 'id', isCheck: true, disabled: false, width: 150 },
        { label: this.$t('rateCalculator.table.CustomerName'), prop: 'customName', isCheck: true, disabled: false },
        { label: this.$t('rateCalculator.table.profitmargin'), prop: 'profitMargin', isCheck: true, disabled: false, width: 120 },
        { label: this.$t('rateCalculator.table.ShippingAddress'), prop: 'fromAddress', isCheck: true, disabled: false },
        // { label: this.$t('rateCalculator.table.Deliveryaddress'), prop: 'deliveryAddress', isCheck: true, disabled: false },
        { label: this.$t('rateCalculator.table.totalcost')+this.$t('rateCalculator.tables.exclGST'), prop: 'totalCost', isCheck: true, disabled: false },
        { label: this.$t('rateCalculator.table.Totalquotation')+this.$t('rateCalculator.tables.exclGST'), prop: 'totalQuote', isCheck: true, disabled: false },
        { label: this.$t('rateCalculator.table.CustomerTotalPrice'), prop: 'totalCustomPrice', isCheck: true, disabled: false, width: 170 },
        { label: this.$t('rateCalculator.table.TotalDifference'), prop: 'totalDiff', isCheck: true, disabled: false },
        { label: this.$t('rateCalculator.table.PercentageDifference'), prop: 'totalPercentage', isCheck: true, disabled: false, width: 180 },
        // { label: this.$t('rateCalculator.table.CalculateTheTotal'), prop: 'buffer', isCheck: true, disabled: false },
        { label: this.$t('rateCalculator.table.TotalNumberOfArticles'), prop: 'totalCount', isCheck: true, disabled: false },
        { label: this.$t('rateCalculator.table.NumberOfCompletedItems'), prop: 'completedCount', isCheck: true, disabled: false, width: 150 },
        { label: this.$t('table.createTimeText'), prop: 'creationDate', isCheck: true, disabled: false },
        { label: this.$t('goodsBrand.page.Status'), prop: 'isCompleted', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 125 },
      ],
      STATUS_ENABLED_NUM,
      dataTime: [],
      dialogFormVisible: false,
      rulesDialogVisible: false
    };
  },
  watch: {
    dataTime(v) {
      this.queryParams.startDate = (v || [])[0];
      this.queryParams.endDate = (v || [])[1];
    }
  },
  mounted() { },
  methods: {
    command(text, row) {
      if (!row.isCompleted) return this.$message.warning(this.$t('pendingApi'))
      switch (text) {
        case 'editText':
          this.onEdit(row);
          break;
        case 'downloadText':
          this.onDown(row);
          break;
      }
    },
    // 批量取消
    bulkCancel() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
        return;
      }
      const ids = this.selectedRows.filter(item => !item.isCompleted&&item.isCancel==0).map(item => item.id);
      if(ids.length==0){
        this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning3'));
        return;
      }else{
        const POST_DATA = {ids:ids,isCancel:1}
        this.$confirm(this.$t('InternalSalesOrderDetails.want')).then(() => {
          thirdApi.bulkCancelStatus(POST_DATA).then(res => {
            if (res.failed === false) {
              setTimeout(() => {
                this.$message.success(this.$t('toast.operationSuccessText'));
                this.reFresh();
              }, 2000);
            }
          });
        });
      }
    },
    showRuleDialog() {
      this.rulesDialogVisible = true;
    },
    // 上传
    add() {
      this.$refs.DataForm.show();
    },
    addType(row) {
      if (!row.isCompleted) {
        this.$message.warning(this.$t('pendingApi'))
      } else {
        const { id } = row;
        this.$toPage('BusinessFreightCalculationDetails', { id });
      }
    },
    // 编辑
    onEdit(row) {
      this.form.id = row.id;
      this.form.profitMargin = row.profitMargin;
      this.dialogFormVisible = true;
    },
    async onDown(row) {
      const res = await afterApi.detailsExports({ id: row.id });
      downloadBlob(res, row.fileName?row.fileName:'Online Store Product.xlsx')
    },
    saveAmount() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          afterApi.detailsEdit(this.form).then(() => {
            this.dialogFormVisible = false;
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.reFresh();
          });
        }
      });
    },
    beforeResetSearch() {
      this.dataTime = [];
      this.queryParams.startCreationDate = null;
      this.queryParams.endLastUpdateDate = null;
      return new Promise(resolve => {
        resolve();
      });
    },
  },
};
</script>

<style scoped>
::v-deep .bj-page .el-form-item__label {
  display: none;
}
</style>
